var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useState, useEffect } from 'react';
import { apiBase } from '../api/axios-client';
import { isLoggedIn } from '../utils/customer';
import { ERR_REDIRECT } from '../constants/response-error-messages';
export var useInterceptors = function () {
    var _a = __read(useState(null), 2), redirectError = _a[0], setRedirectError = _a[1];
    useEffect(function () {
        if (!isLoggedIn()) {
            redirectToSignIn();
        }
    }, []);
    var redirectToSignIn = function () {
        if (typeof window !== 'undefined') {
            window.location.replace("/auth/view/signin?redirect=".concat(encodeURIComponent(window.location.pathname + window.location.search)));
        }
        setRedirectError(ERR_REDIRECT);
    };
    var logonMiddleware = function (error, errorCodes) {
        var response = error.response;
        var hasError = errorCodes.find(function (i) { return (response === null || response === void 0 ? void 0 : response.status) === i; });
        if (response && hasError) {
            redirectToSignIn();
        }
        return Promise.reject(error);
    };
    var apiErrorCodesB2B = [401, 431];
    apiBase.interceptors.response.use(undefined, function (error) {
        return logonMiddleware(error, apiErrorCodesB2B);
    });
    return {
        redirectError: redirectError,
    };
};
